var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { $auth } from '../entities/auth';
const INITIAL_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
class RestApi {
    constructor() {
        this.axiosInstance = axios.create({
            headers: INITIAL_HEADERS,
        });
    }
    static getDefaultAccessToken() {
        if (RestApi.getAccessToken) {
            return RestApi.getAccessToken;
        }
        if ($auth === null || $auth === void 0 ? void 0 : $auth.getAccessToken) {
            return $auth.getAccessToken.bind($auth);
        }
        return null;
    }
    static getInstance() {
        if (!RestApi.instance)
            RestApi.instance = new RestApi();
        return RestApi.instance;
    }
    static getAxios() {
        return RestApi.getInstance().axiosInstance;
    }
    static setGetAccessToken(fn) {
        RestApi.getAccessToken = fn;
    }
    static request(url, options) {
        const { method = 'get', payload, config, bearerToken } = options || {};
        const requestConfig = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign(Object.assign({}, INITIAL_HEADERS), config === null || config === void 0 ? void 0 : config.headers), (bearerToken && { Authorization: `Bearer ${bearerToken}` })) });
        switch (method.toUpperCase()) {
            case 'GET':
                return RestApi.getAxios().get(url, requestConfig);
            case 'POST':
                return RestApi.getAxios().post(url, payload, requestConfig);
            case 'PUT':
                return RestApi.getAxios().put(url, payload, requestConfig);
            case 'DELETE':
                return RestApi.getAxios().delete(url, requestConfig);
            case 'PATCH':
                return RestApi.getAxios().patch(url, payload, requestConfig);
            default:
                throw new Error(`Unsupported HTTP method: ${method}`);
        }
    }
    static requestLogged(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { method = 'get', payload, config, bearerToken, roleId } = options || {};
            let token = bearerToken;
            if (!token) {
                const getToken = RestApi.getDefaultAccessToken();
                if (getToken) {
                    token = (yield getToken(roleId)) || undefined;
                }
            }
            return RestApi.request(url, { method, payload, config, bearerToken: token });
        });
    }
}
RestApi.getAccessToken = null;
export default RestApi;
